import API from "../../../../../global/api";
import jsPDF from "jspdf";
import moment from "moment";
import { PDFHeader } from "../../../../../global/globalFunctions";
// import _ from "lodash";


export const requestChartOfAccountPDF = () => {
    return {
        type: "REQUEST_CHART_OF_ACCOUNT_PDF",
    };
};
export const successChartOfAccountPDF = (data) => {
    return {
        type: "SUCCESS_CHART_OF_ACCOUNT_PDF",
        payload: data,
    };
};
export const errorChartOfAccountPDF = () => {
    return {
        type: "ERROR_CHART_OF_ACCOUNT_PDF",
    };
};
export const ChartOfAccountPDFApi = (data) => {
    return (dispatch) => {
        dispatch(requestChartOfAccountPDF());
        API.post(`/reports/chart_of_account_report`, data).then((res) => {
            dispatch(successChartOfAccountPDF(res.data));
            let getData = res.data.data;

            const unit = "pt";
            const size = "A4";
            const orientation = "p";
            const doc = new jsPDF(orientation, unit, size);
            PDFHeader(doc, "Chart Of Account");

            let y = 130;
            getData.forEach((levelOne) => {
                doc.setFontSize(12);
                doc.setFont("TimesNewRoman", "bold");
                doc.text(`${levelOne.key} - ${levelOne.name}`, 40, y);
                y += 20;

                (levelOne.levelTwoArray || []).forEach((levelTwo) => {
                    doc.setFontSize(12);
                    doc.setFont("TimesNewRoman", "bold");
                    doc.text(`${levelTwo.allKey} - ${levelTwo.levelTwoName}`, 60, y);
                    y += 20;

                    (levelTwo.levelThreeArray || []).forEach((levelThree) => {
                        doc.setFontSize(12);
                        doc.setFont("TimesNewRoman", "bold");
                        doc.text(`${levelThree.allLevlKey} - ${levelThree.levelThreeName}`, 80, y);
                        y += 20;

                        // LevelFour table
                        if (levelThree.levelFourArray && levelThree.levelFourArray.length > 0) {
                            const tableData = levelThree.levelFourArray.map((l4) => [
                                l4.levelFourKey,
                                l4.levelFourName,
                                l4.allLevelKey,
                            ]);

                            doc.autoTable({
                                head: [["Key", "Name", "All Key"]],
                                body: tableData,
                                startY: y,
                                theme: "grid",
                                styles: { fontSize: 10 },
                                margin: { left: 100 },
                            });

                            y = doc.lastAutoTable.finalY + 20;
                        }
                    });
                });
            });

            doc.setProperties({ title: `Chart of Account - ${moment().format("YYYY-MM-DD")}.pdf` });
            var blob = doc.output("blob");
            window.open(URL.createObjectURL(blob));

        }).catch((error) => {
            dispatch(errorChartOfAccountPDF());
        });
    };
};